﻿import {ValidationMessage} from '../validationMessage';
import {ValidationMessageType} from '../validationMessageType';
import {InvalidEmail } from '../validationConstants';
import {ValidateResult} from '../validateResult';
import {IValidator} from './iValidator';

export class EmailValidator implements IValidator {
    public validate(value: any, propertyName, propertydisplayName, errorMessage): ValidateResult {
        let result = new ValidateResult();
        var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!value) {
            return result;
        }

        if (emailRegex.test(value)) {
            return result;
        }

        let vm = new ValidationMessage();
        if (typeof errorMessage == 'undefined' || errorMessage == null || errorMessage == '') {
            vm.message = InvalidEmail;
        } else {
            vm.message = errorMessage;
        }
        vm.propertyName = propertyName;
        vm.messageType = ValidationMessageType.Error;
        result.validationMessage = vm;
        return result;
    }

    public validateEmail(value: any): Boolean {
        var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!value) {
            return true;
        }

        if (emailRegex.test(value)) {
            return true;
        }
        return false;
    }
}   